export default __webpack_public_path__ + "static/media/BarteredBride.de122841.mp4";